import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ACTIVATE_BUTTON: `${cleanedFilename(__filename)}-activate-button`,
  TERMS_CHECKBOX: `${cleanedFilename(__filename)}-terms-checkbox`,
  TEXT_AREA: `${cleanedFilename(__filename)}-text-area`,
};
